<script setup lang="ts">
import 'altcha'
import { ref } from 'vue'

const payload = defineModel<string>({ default: '' })

const widget = ref<HTMLElementTagNameMap['altcha-widget'] | null>(null)

function onStateChange(event: Event) {
  const detail = (event as CustomEvent<{ payload?: string, state: string }>).detail

  payload.value = detail.state === 'verified' ? (detail.payload ?? '') : ''
}

// Each solution counts once, so a form the server sent back needs a fresh one.
function reset() {
  payload.value = ''
  widget.value?.reset()
  void widget.value?.verify()
}

defineExpose({ reset })
</script>

<template>
  <altcha-widget
    ref="widget"
    auto="onload"
    challenge="/api/altcha-challenge"
    class="altcha-field"
    @statechange="onStateChange"
  />
</template>

<style scoped>
.altcha-field {
  --altcha-border-color: var(--line-strong);
  --altcha-border-radius: 0.5rem;
  --altcha-color-primary: var(--brand);
  --altcha-max-width: 100%;
  display: block;
}
</style>
